import React from 'react';
import './experiences.css';
import { Footer } from '../../components';
import ExperiencesContainer from './ExperiencesContainer';

const ExperiencesList = () => {
  return (
    <>
      <ExperiencesContainer 
        background={true}
        name={"Student Research Trainee at University of Toronto"}
        type={"Type: Research Trainee"}
        date={"Date: Jun. 2025 - Aug. 2025"}
        position={"Position: Student Researcher"}
        description={
          <>
            Charles worked as a student research trainee at the Center of 
            Excellence for Networking Innovation in Toronto (CENIT). His primary
            role is to perform simulations of routing algorithms using the 
            NS-3 simulator in C++. He has worked alongside Professor J.J. 
            Garcia-Luna-Aceves (Canada Excellence Research Chair), to co-publish
            two papers. The papers are published to the 2025 16th International 
            Conference on Network of the Future (NoF) and the 2025 12th 
            International Symposium on Networks, Computers and Communications 
            (ISNCC).
            <br /><br />
            One of the features Charles worked on was a JSON logging mechanism 
            within NS-3 to determine the precise convergence time. This is done 
            by having routers log the time whenever they send or receive a 
            non-periodic message. This approach significantly reduce the storage 
            needed in comparison with the old method of calculating the 
            convergence time from routing tables. He has also revamped the 
            node-failure and node-recovery events to activate or disable 
            communication across multiple links at the same time instead of 
            doing them sequentially. By doing so, it ensures that failed links 
            are disabled at the start of the simulation for recovery events.
            <br /><br />
            In addition to simulating the routing algorithms that CENIT has 
            developed, he implemented a minimal version of OSPF (RFC 2328) in 
            NS-3. This allows the research group to perform various experiments 
            and tweak different parameters as needed.
            <br /><br />
            Furthermore, Charles passed down his knowledge of NS-3 to a fellow 
            PhD student at CENIT. This enables the PhD student to perform their 
            research on methods to improve network security via blockchains. 
            This required Charles to improve the existing documentation of the
            codebases and collaborate carefully with others.
          </>
        }
      />

      <ExperiencesContainer 
        background={false}
        name={"Computer Network Research Intern at University of Toronto"}
        type={"Type: Research Intern"}
        date={"Date: May. 2024 - Aug. 2024"}
        position={"Position: Undergraduate Researcher"}
        description={
          <>
            Charles worked as an research intern at the Center of Excellence for 
            Networking Innovation in Toronto (CENIT). His main duty is to use 
            the NS-3 simulator in C++ to simulate new routing algorithms 
            developed by the CENIT and benchmark them against the state of the 
            art protocols such as OSPF, RIPv2, and DSDV. As the co-author of 
            <a href="https://xplorestaging.ieee.org/document/10850473"> this 
            paper</a>, Charles worked alongside Professor J.J. 
            Garcia-Luna-Aceves (Canada Excellence Research Chair) to develop 
            novel shortest multi-path routing algorithms which are loop-free at 
            every instance. By avoiding routing table loops at all times, these 
            algorithms do not waste resources. In addition, it does not have to 
            slow down its messaging for the purposes of route flapping or 
            excessive signaling. The multi-path nature of these algorithms serve 
            as a major advantage over Diffusing Update Algorithm (DUAL) used in 
            EIGRP as it permits the forwarding of messages along loop-free paths 
            while the algorithm is converging to the shortest path. As a result, 
            this minimizes the time that a router spends idling. Through the 
            simulation results, it has been shown that these algorithms 
            converges faster than OSPF, RIPv2, and DSDV after link-failure, 
            link-recovery, node-failure, and node-recovery events.
            <br /><br />
            Charles also improved the automation process associated with data 
            collection by refactoring and adding new features to the Python and 
            Bash scripts. These scripts connect with the NS-3 library to run 
            simulations of interest, perform log compression, and generate 
            important statistics such as convergence time and overhead. He also 
            added a feature to count the number of synchronous steps that an 
            algorithm takes to converge as a result of an induced event despite 
            the asynchronous nature of NS-3. To do so, he used various libraries 
            like Pandas, NumPy, Subprocess, Argparse, Psutil, and JSON.
            <br /><br />
            Charles also implemented existing algorithms of the Ideal Link 
            State and Diffusing Update (DUAL) using the NS-3 simulator in C++. 
            Although DUAL is published and standardized, it is not implemented 
            in NS-3. Furthermore, the built-in version of OLSR and OSPF lacked 
            the flexibility that CENIT needs for the benchmarking purposes. The 
            implementations are designed to be faster than the DCE version of 
            OSPF allowing more tests to be run at a shorter time.
            <br /><br />
            Charles worked with Google Cloud Compute Engine, Hyper-V VMs, and a 
            native Ubuntu PC to speed up the workload associated with the 
            NS-3 simulations. He learned how to install the Ubuntu OS onto a 
            real machine using Etcher.
          </>
        }
      />
      
      <ExperiencesContainer 
        background={true}
        name={"Engineering Strategies & Practice I & II"}
        type={"Type: Academic"}
        date={"Date: Sep. 2021 - Apr. 2022"}
        position={"Position: Meeting Coordinator / Member"}
        description={
          <>
            Engineering Strategies and Practice, often known as "ESP", are 
            courses offered to first year Engineering students to practice the 
            skills of design through real-life projects. The ESP courses are 
            split between 2 semesters, meaning that Charles has worked on 2 
            different projects. His meeting coordinator role allowed him to 
            learn different ways to communicate amongst his team, client, and 
            manager. Through this process, he has learned the core concepts of 
            design.
            <br /><br />
            The first project was about creating a mechanism to allow a food 
            delivery robot to efficiently unload its package to the customer in 
            a user-friendly way. Through a team of 5, the final design featured 
            multiple components. The central component uses a 4-bar linkage 
            system to unload the food at an appropriate height similar to how
            a waiter would serve food. For safety reasons, it includes QR app to 
            ensure that the food is delivered to the right customers and uses UV 
            light to sanitize the package to meet the COVID-19 regulations. The 
            design includes components to enhance its durability such as 
            waterproof materials, heat insulators, a GPS tracker, and 6 
            all-terrain wheels.
            <br /><br />
            In the second project, Charles worked with a client. His client, 
            Emerson Canada, wanted his team of 6, to develop methods to reduce 
            greenhouse gas (GHG) emission in the City of Toronto. The final 
            design featured a multi-layered wall insulation that consists of 
            using fiberglass, expanded polystyrene foam, and polyurethane foam. 
            By conducting physical experiments, the design proved to have a high 
            heat resistance while being relatively cheap. It required no 
            maintenance and the entire process from production to implementation
            yields a low carbon footprint.
          </>
        }
      />

      {/* <ExperiencesContainer 
        background={false}
        name={
          <>
            Toward More Effective Teaching and Learning in Engineering Education
          </>
        }
        type={"Type: Academic"}
        date={"Date: Jul. 2022"}
        position={"Position: Focus Group Participant"}
        description={
          <>
            This is a research project conducted by University of Toronto and is led by
            "Institute for Studies in Transdisciplinary Engineering Education and 
            Practice" (ISTEP). This research study is intended to look at the learning
            effectiveness of different types of instruction that been presented as a result
            of the COVID-19 pandemic. The types of instruction include in-person, online 
            synchronous, and asynchronous learning. Dr. Qin Liu has talked with Charles 
            about ways to boost learning efficiency and tailoring the ideal blend
            of instruction for future courses. By taking the unique advantages of each 
            type of instruction, the project hopes to take another step into perfecting
            Engineering education. 
          </>
        }
      />

      <ExperiencesContainer 
        background={false}
        name={"Junior Optimist Club of Oakville"}
        type={"Type: Volunteer"}
        date={"Date: Jul. 2017 - Oct. 2020"}
        position={"Position: Member"}
        description={
          <>
            The Junior Optimist Club of Oakville is a non-profit organization
            that believes in the potential of youth. To fulfill this potential,
            the clubs host local fundraiser events throughout the year. It works with
            other organizations such as the Food Bank, Food4Kids, and YMCA to deliver 
            this aid.
            <br /><br />
            Charles' role as a member is to facilitate the preparation needed to host these events.
            This includes managing, gathering, and finding the necessary materials. This task
            requires leadership and communication skills as the club needs to work efficiently 
            under small groups. This enhanced his ability to plan and organize in
            order to meet their various deadlines.
          </>
        }
      />

      <ExperiencesContainer 
        background={true}
        name={"Fo Guan Shan Temple of Toronto"}
        type={"Type: Volunteer"}
        date={"Date: Jun. 2020 - Jul. 2020"}
        position={"Position: N/A"}
        description={
          <>
            This volunteer task involves working in the audio-visual department to create an 
            archive system for the hundreds of CDs, videotapes, and cassette players stored 
            in the temple. Thus, this requires a decent amount of organization as well as
            dedication to create a coherent system.
            <br /><br />
            However, Charles volunteer under an unprecedented situation as Ontario was still in a 
            state of emergency due to COVID-19. For him to volunteer in person, he had to get 
            special permission which involves the creation of a concrete plan to limit the 
            spread of the virus. By communicating effectively wit his coordinator, they came up
            with a plan that includes rigorous disinfection, PPEs, and self-conducting surveys.
          </>
        }
      />

      <ExperiencesContainer 
        background={false}
        name={"Central Ontario Leadership Seminar"}
        type={"Type: Nominated from High School"}
        date={"Date: May 2019"}
        position={"Position: Participant"}
        description={
          <>
            This seminar is held at the University of Toronto Mississauga Campus. Its
            purpose is to enhance leadership skills through a series of activities, workshops, 
            lectures, and exercises. Through this training, Charles' communication, teamwork, 
            and collaboration skills were leveraged. Moreover, the seminar spanned over a short 
            period giving him the opportunity to get along with others quickly and find methods to 
            work well amongst a diverse group.
          </>
        }
      />

      <ExperiencesContainer 
        background={true}
        name={"Social Justice Club"}
        type={"Type: Extra-curricular"}
        date={"Date: Oct. 2017 - Mar. 2019"}
        position={"Position: Member"}
        description={
          <>
            The social justice club is a school club designed to help those that are struggling
            financially in the Greater Toronto Area (GTA). This vision is executed by creating
            a series of local fundraisers to raise necessities such as food, money, and water.
            These donations are later sent to other NGOs to ease their suffering.
            <br /><br />
            Being a member, Charles has drastically enhanced his marketing skills. Since 
            the donations are a key element to sustaining the club, he had to seek ways to 
            optimize these events. He needed to draw upon his strong logistics and data 
            analysis skills to see which events people enjoy, how to raise more awareness, and 
            how to reach a larger audience. He also utilized his leadership skills to 
            guide and unite the club in order to work towards the same vision.
          </>
        }
      />

      <ExperiencesContainer 
        background={false}
        name={"Oakville Little League Baseball"}
        type={"Type: Volunteer"}
        date={"Date: May 2017 - Oct. 2017"}
        position={"Position: N/A"}
        description={
          <>
            The Oakville Little League Baseball is a developmental program for youth baseball.
            Under this organization, Charles served as a volunteer with his role fluctuating between
            the equipment crew and the official scorecard keeper.
            <br /><br />
            As a equipment crew, Charles learned how to use leadership skills to allow his group to 
            deliver equipments on time and with the right set of procedure. Communication was used 
            extensively amongst his team and his manager to ensure that all the protocols were met 
            and the games are run smoothly.
            <br /><br />
            The other role of being the official scorecard keeper trained his ability to concentrate 
            for long-duration of time. Since the games he covered where mostly championship games, 
            Charles needed accuracy, precision, and accountability to be reflected in his work. 
          </>
        }
      /> */}
    </>
  )
}

const Experiences = () => {
  return (
    <>
      <div className="charles__experiences section__padding">
        <h1 className="gradient__text">Experiences</h1>

        <p>
          This page shows all the experiences that Charles has gained through 
          his professional, academic, and extra-curricular endeavour.
        </p>
        <ExperiencesList />
      </div>
      <Footer />
    </>
  )
}

export default Experiences